import React, { useEffect, useRef } from "../../__compat__/react/main.entry.mjs.mjs";
import { Button } from "../index.mjs.mjs";
import { StyledDialog, StyledDialogCloseButton } from "./Dialog.styles.mjs.mjs";
export const Dialog = ({ children, open, triggerButton, onCloseX, dialogAriaProps, }) => {
    const dialogRef = useRef(null);
    useEffect(() => {
        const element = dialogRef.current;
        if (!element) {
            return;
        }
        if (open) {
            return element.showModal();
        }
        return element.close();
    }, [open]);
    return (React.createElement(React.Fragment, null,
        triggerButton && (React.createElement(Button, { ...triggerButton }, triggerButton.label)),
        React.createElement(StyledDialog, { ref: dialogRef, "aria-describedby": dialogAriaProps === null || dialogAriaProps === void 0 ? void 0 : dialogAriaProps.ariaDescribedBy, "aria-labelledby": dialogAriaProps === null || dialogAriaProps === void 0 ? void 0 : dialogAriaProps.ariaLabelledBy },
            onCloseX && (React.createElement(StyledDialogCloseButton, null,
                React.createElement(Button, { variant: "icon-tertiary", icon: "cancel", onClick: onCloseX }))),
            children)));
};
Dialog.displayName = 'Dialog';
//# sourceMappingURL=Dialog.mjs.mjs.map